export const STATUS_INIT = 0;
export const STATUS_BEGIN = 1;
export const STATUS_DONE = 2;
export const STATUS_FAIL = 3;